import ViewActivityBeforeIn from "./viewActivityBeforeIn";

export default ViewActivityBeforeIn;
